export default "__VITE_ASSET__DxsMxTiN__"